import { cn } from '@shared/utils';

interface IMessageWrapperProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const MessageWrapper = (props: IMessageWrapperProps) => {
  return (
    <div className={cn('mb-2', props.className)} onClick={props.onClick}>
      <div className={cn('flex rounded-sm bg-white p-5 dark:bg-soft-black', props.contentClassName)}>{props.children}</div>
    </div>
  );
};
